export const SCROLL_MULTIPLIER = 2
export const DEFAULT_TEXT_COLOR = '$dark-light'
export const ARIA_LABEL_DEFAULT = 'Scrollable cell content'

export const CURSOR_TYPES = {
  GRAB: 'grab',
  GRABBING: 'grabbing'
}

export const MOUSE_EVENTS = {
  MOVE: 'mousemove',
  UP: 'mouseup'
}

export const KEYBOARD_EVENTS = {
  ENTER: 'Enter',
  SPACE: ' '
}

export const EVENTS_STATUS = Object.freeze({
  FINISHED: 'FINISHED',
  PROGRAMMED: 'PROGRAMMED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
})

export default () => {}
